
$(function() {
    $("body").on("click",".ajax-delete-modules-submit",function() {

        var $modal=$(this).parents('.modal');
        var row=$(this).parents('.super-menu-drag');
        $.ajax({
            method:'delete',

            url:'/frontend/api/modules/'+$(this).attr("data-id"),




            sfdata:{
                _token:$(this).attr("data-csrf")
            }
        }).always(function(){
            $modal.hide();
            $('.modal-backdrop.fade.in').remove();
            GlobalManager.trigger('reload');
            row.remove();

        });
    });
});